'use client'

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { SidebarStore } from './types'

/**
 * Global sidebar state hook with localStorage persistence
 *
 * Provides:
 * - isCollapsed: Current collapse state
 * - toggle(): Toggle collapse state
 * - collapse(): Force collapsed state
 * - expand(): Force expanded state
 *
 * State persists across sessions via localStorage
 */
export const useSidebar = create<SidebarStore>()(
  persist(
    (set) => ({
      // State. Collapsed until the broker opens it; their choice is then kept.
      isCollapsed: true,

      // Actions
      toggle: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
      collapse: () => set({ isCollapsed: true }),
      expand: () => set({ isCollapsed: false }),
    }),
    {
      name: 'sidebar-state', // localStorage key
    }
  )
)
